import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SDKAppID } from '../debug/GenerateTestUserSig';
import { TUILogin } from "@tencentcloud/tui-core";
import '@tencentcloud/chat-uikit-react/dist/cjs/index.css'
import './style.scss'
import { loginOverseas } from './api';
import TaskBar from './TaskBar';
import { taskList as taskListDefault, taskLiveList as taskLiveListDefault, taskBotList as taskBotListDefault } from "./TaskBarJson";
import SocialDemo from '../social-demo';
import LiveDemo from '../live-demo/live-demo';
import BotDemo from '../bot-demo';
import live from './assets/image/live.png';
import lived from './assets/image/lived.png';
import social from './assets/image/social.png';
import socialed from './assets/image/socialed.png';
import languageIcon from './assets/image/language.svg';
import bot from './assets/image/bot.png';
import boted from './assets/image/boted.png';

const languageList = [
  {
    label: '简体中文',
    value: 'zh'
  },
  {
    label: 'English',
    value: 'en'
  }
]

interface loginInfoParams {
  SDKAppID: number,
  userID: string,
  userSig: string,
  useUploadPlugin?: boolean,
}

const useParams = () => {
  const keywords = window.location.search;
  let params: any = {};
  if (keywords) {
    const result = keywords.slice(1).replace(/&/g, '","').replace(/=/g, '":"');
    const reqDataString = `{"${result}"}`;
    params = JSON.parse(reqDataString)
  }
  return params;
}

export default function SampleChat() {
  const SCENE_MENU_ID_MAP: any = {
    social: 1,
    live: 2,
    bot: 3
  }
  const params = useParams();
  const { i18n } = useTranslation();
  const { scene, task = 'true' } = params;
  if (!scene) {
    const currentUrl = window.location.href;
    const newUrl = currentUrl + (currentUrl.includes('?') ? '&' : '?') + 'scene=social';
    window.location.href = newUrl;
  }
  const menuID = SCENE_MENU_ID_MAP[scene] || 1;
  const isTaskBar = task === 'false' ? false : true;
  const [chat, setChat] = useState<any>();
  const [taskList, setTaskList] = useState(taskListDefault);
  const [taskLiveList, setTaskLiveList] = useState(taskLiveListDefault);
  const [taskBotList, setTaskBotList] = useState(taskBotListDefault)
  const [currentMenu, setCurrentMenu] = useState(menuID);
  const [currentLng, setCurrentLng] = useState({
    label: 'English',
    value: 'en'
  });
  const [isShowLngPop, setShowLngPop] = useState(false);

  const init = (SDKAppID: number, userID: string, userSig: string) => {
    const loginInfo: loginInfoParams = {
      SDKAppID,
      userID,
      userSig,
      useUploadPlugin: true,
    };
    TUILogin.login(loginInfo).then((res: any) => {
      const { chat } = TUILogin.getContext();
      setChat(chat);
    });
  }

  useEffect(() => {
    (async () => {
      const res = await loginOverseas();
      const { userID, userSig } = res.data;
      i18n.changeLanguage(currentLng.value)
      init(SDKAppID, userID, userSig);
    })()
  }, [])

  const handleNewTaskList = (key: string, taskList: Array<object>) => {
    return taskList.map((item: any) => {
      if (item.key === key) {
        item.value = true;
      }
      return item;
    })

  }
  const handleTaskLiveList = (key: string) => {
    const newTaskList = handleNewTaskList(key, taskLiveList);
    setTaskLiveList(newTaskList);
  }

  const handleTaskList = (key: string) => {
    const newTaskList = handleNewTaskList(key, taskList);
    setTaskList(newTaskList);
  }

  const handleTaskBotList = (key: string) => {
    const newTaskList = handleNewTaskList(key, taskBotList);
    setTaskBotList(newTaskList);
  }

  const handleSelect = (item: any) => {
    if (scene) {
      let paramsString = '?';
      for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
          let value = params[key];
          if (key === 'scene') {
            value = item.value;
          }
          paramsString += `${key}=${value}&`
        }
      }
      window.location.href = `${window.location.origin}${window.location.pathname}${paramsString.slice(0, -1)}`;
    } else {
      setCurrentMenu(item.id);
    }
  };


  const changeLanguage = (lng: any) => {
    setCurrentLng(lng);
    i18n.changeLanguage(lng.value);
    setShowLngPop(!isShowLngPop);
  };

  function choiceResult(id: Number, prop: any) {
    const menuItem: any = menuList.find(item => item.id === id);
    return menuItem ? menuItem[prop] : null;
  }

  const menuList = [
    {
      id: 1,
      name: 'Social Messenger',
      icon: social,
      selectedIcon: socialed,
      value: 'social',
      taskList: taskList,
      mainDemo: <SocialDemo chat={chat} handleTaskList={handleTaskList} />
    },
    {
      id: 2,
      name: 'Live Streaming',
      icon: live,
      selectedIcon: lived,
      value: 'live',
      taskList: taskLiveList,
      mainDemo: <LiveDemo chat={chat} handleTaskList={handleTaskLiveList} />
    },
    {
      id: 3,
      name: 'AI Chatbot',
      icon: bot,
      selectedIcon: boted,
      value: 'bot',
      taskList: taskBotList,
      mainDemo: <BotDemo chat={chat} handleTaskList={handleTaskBotList} />
    },
  ]

  return (
    <>
      {isTaskBar && (
        <TaskBar
          taskList={choiceResult(currentMenu, "taskList")}
          language={currentLng.value}
        />
      )}
      <div className="chat-demo">
        <div className="chat-header">
          <ul className="header-menu">
            {menuList.map((item) => (
              <li
                key={item.name}
                className={`menu-default ${item.id === currentMenu ? "menu-select" : "menu-unselect"
                  }`}
                onClick={() => {
                  handleSelect(item);
                }}
              >
                <img
                  className="menu-icon"
                  src={
                    item.id === currentMenu ? item?.selectedIcon : item?.icon
                  }
                  alt=""
                />
                <span>{item?.name}</span>
              </li>
            ))}
          </ul>
          <div className="language-container">
            <div
              className="title-container"
              onClick={() => setShowLngPop(!isShowLngPop)}
            >
              <img className="language-icon" src={languageIcon} alt="" />
              <p className="language-text">{currentLng.label}</p>
            </div>
            {isShowLngPop && (
              <div className="language-item-container">
                {" "}
                {languageList.map((item, index) => {
                  const key = `${item.value}${index}`;
                  return (
                    <p
                      className="language-text"
                      role="menuitem"
                      tabIndex={index}
                      key={key}
                      onClick={() => {
                        changeLanguage(item);
                      }}
                    >
                      {item.label}
                    </p>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        <div className="chat-main">{choiceResult(currentMenu, "mainDemo")}</div>
      </div>
    </>
  );
}
